import { combineReducers } from '@reduxjs/toolkit';

import { headerReducer } from 'widgets/Header';
import {
	authService,
	csvService,
	dictionaryService,
	profileService,
	projectsService,
	searchService,
	sharedService,
	similarSkillsService,
	subscriptionService,
	integrationService,
	companySearchService
} from 'services';

import { credentialsReducer } from './credentials';
import { messagesReducer } from './messages';

export const REDUCERS = {
	header: headerReducer,
	credentials: credentialsReducer,
	messages: messagesReducer,
	[authService.reducerPath]: authService.reducer,
	[dictionaryService.reducerPath]: dictionaryService.reducer,
	[searchService.reducerPath]: searchService.reducer,
	[subscriptionService.reducerPath]: subscriptionService.reducer,
	[profileService.reducerPath]: profileService.reducer,
	[similarSkillsService.reducerPath]: similarSkillsService.reducer,
	[csvService.reducerPath]: csvService.reducer,
	[sharedService.reducerPath]: sharedService.reducer,
	[projectsService.reducerPath]: projectsService.reducer,
	[integrationService.reducerPath]: integrationService.reducer,
	[companySearchService.reducerPath]: companySearchService.reducer
};

export const rootReducer = combineReducers(REDUCERS);
